import { render, staticRenderFns } from "./detail_local_delivery.vue?vue&type=template&id=c6053d7e&scoped=true"
import script from "./detail_local_delivery.vue?vue&type=script&lang=js"
export * from "./detail_local_delivery.vue?vue&type=script&lang=js"
import style0 from "./detail_local_delivery.vue?vue&type=style&index=0&id=c6053d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6053d7e",
  null
  
)

export default component.exports